export default __webpack_public_path__ + "static/java-development-company-peerbits-de3ff6bfa4793103665d5b4cc114d851.png";